export const faq = {
  question1: "What is Mobilawy?",
  answer1:
    "Mobilawy is ExxonMobil Egypt’s loyalty program that enables you to collect points when you fill your car with at least 25 liters of Mobil Super Plus 95 at any of the participating services stations that have On The Run, The Way To Go or/and upon purchasing any Mobil oil package from the oil types participating in the program. The accumulated points can be used as an alternative payment method, either totally or partially, with service providers participating in the program. That enables clients to get what they need from the products and /or services available within any branch of the joint service providers in the program within Egypt.",
  question2:
    "What are the oil types and service stations participating in the program?",
  answer2: {
    participatingStation: "Participating Services Stations",
    zayed: "Zayed",
    zamalek: "Zamalek",
    wBalad: "W. Balad",
    urban1: "Urban 1",
    tagamoa: "Tagamoa",
    sphinx: "Sphinx",
    smoha: "Smoha",
    shatby: "Shatby",
    sadat: "Sadat Academy",
    roxy: "Roxy",
    roshdy: "Roshdy",
    rehab: "Rehab",
    orouba: "Orouba",
    october: "October",
    oboroie: "Oboroie",
    nozha: "Nozha",
    nour: "Nour",
    newMaadi: "New Maadi",
    nasrRoad: "Nasr Road",
    narges: "Narges",
    mohandessin: "Mohandessin",
    merghem: "Merghem Alex Desert Road",
    merghany: "Merghany",
    mariottya: "Mariottya",
    marina: "Marina",
    manial: "Manial",
    madinty: "Madinty",
    maadiTowers: "Maadi Towers",
    ibrahimeya: "Ibrahimeya",
    hegaz: "Hegaz",
    hassanElMaamoun: "Hassan EL Maamoun",
    gametElDowal: "Gamaet El Dowal",
    fardous: "Fardous",
    dokki: "Dokki",
    cornich: "Cornich",
    concordPlaze: "Concord Plaza",
    batal: "Batal",
    bakry: "Bakry",
    autostrad: "Autostrad",
    amreya: "Amerya(Alex.)",
    almaza: "Almaza",
    runway: "Alexandria - Runway",
    airport: "Airport",
    agouza: "Agouza",
    newCairo: "New Cairo",
  },
  question3: "How can I earn points when I use Mobil oil packages?",
  answer3: {
    remove: "Remove Mobilawy front label sticker.",
    accumulate: "Accumulate your points through:",
    application:
      "Application: Click on scan oil on the application to scan the QR code or to add manually the code on the app.",
    send: "SMS: Send the code via SMS to 4432",
    receive:
      "Once points are successfully added, you’ll find the current points balance on the application homepage, and you will receive a short text message including your current points balance.",
  },
  question4: "How can I earn points from Mobil Super Plus 95?",
  answer4: {
    visit:
      "Visit any of the participating service stations that have On the Run or Way to go or Mobilawy and fill your car with at least 25 liters from Mobil Super Plus 95.",
    click:
      "Click on fuel code on the application homepage to open the QR code.",
    show: "Show the QR code to the service station agent to be scanned and to have points added to your wallet.",
    once: "Once points are successfully added, you’ll find the current points balance on the application homepage, and you will receive a short text message including your current points balance.",
    ask: "Ask the service station agent to add the points to your Mobilawy wallet",
    provide:
      "The agent will provide you with a device, on which you enter your mobile number",
    // amount: "The agent will add the amount of points to be added",
    receive:
      "You will receive a short text message including your current points balance and a link to the electronic portal for the program attached to the message.",
  },
  question5: "How can I register or log-in to Mobilawy app?",
  answer5: {
    newAccount: "If you are creating new account, please follow these steps:",
    download: "Download Mobilawy application from Google play/App Store",
    open: "Open Register screen.",
    enter:
      "Enter your mobile number or sign up using social network, you will receive an OTP through SMS",
    otp: "Enter the OTP",
    fullName:
      "Go to complete profile and enter your full name. You can complete the rest of the fields or fill it later.",
    success:
      "After completing the required data, you’ll be registered successfully and can enjoy the full app experience.",
    signOut: "Sign out from the application.",
    settings:
      "Go to mobile settings, make sure that Biometrics and security is not closed from app settings, please make sure to avail them for easy log-in process",
    logIn:
      "Open log-in screen, finger print icon will appear right next to login in button",
    click:
      "Click on the finger print icon, finger print/face ID is done successfully.",
    finger:
      "After availing the fingerprint, you can login to Mobilawy with fingerprint/Face ID",
    existing:
      "If you are logging in with an existing account, please follow these steps:",
    enterSignIn:
      "Enter your mobile number or sign in using social network, you will receive an OTP through SMS",
    otpSignIn: "Enter the OTP and you’ll be logged in successfully.",
    registered:
      "Open Log-in screen enter your registered mobile number and password.",
    logout: "Log out from Mobilawy app.",
  },
  question6: "How can I know my points balance?",
  answer6: {
    logIn:
      "Log in to the application or the portal, you’ll find your points balance on the homepage.",
    check:
      "To check your points balance you must log in via the app or the program's electronic portal sent in the text message by following the steps below:",
    existing: "Consumer Log in: If you have an existing account",
    number: "Enter your mobile phone number",
    password: "Enter Password",
    monitor:
      "Once you log in, you can monitor your earned points balance at home page",
    new: "Consumer Log in: If you have a new account",
    otp: "You will receive an OTP / code vis SMS",
    code: "Enter that code in the designated place on the app.",
    name: "Add Name, Password to the designated place on the app",
    portal: "Portal Log in",
    codePortal: "Enter that code in the designated place on the website.",
    monitorPortal:
      "Once you log in, you can monitor your earned points balance at home page",
  },
  question7: "Where can I redeem my points?",
  answer7:
    "You can redeem your points from Mobilawy program’s Merchants. Merchants are on the program’s web portal and through the points widget on the app.",
  question8: "How to redeem points?",
  answer8: {
    visit: "Visit any branch of service providers throughout Egypt.",
    request:
      "Request to use your Mobilawy points, either totally or partially, to complete the purchase.",
    choose: "Choose the product or service you wish to buy from the merchant.",
    provide: "Provide your mobile number to the cashier to redeem the points.",
    otp: "You’ll receive OTP through SMS.",
    after:
      "After availing the OTP to the merchant, you will receive a short text message including your current points balance after deducting the points.",
  },
  question9: "Can I exchange my points for money?",
  answer9: "Points cannot be exchanged for money.",
  question10: "What is the call center number?",
  answer10: "The call center number is 15177.",
};
